import { CDN_PREFIX } from '@/config/data';
let format = (value) => {
  return value >= 10 ? value : '0' + value;
};
export const filters = {
  cdnPrefix (url) {
    return `${CDN_PREFIX}/${url}`;
  },
  dateFilter: (time, type) => {
    if (!time) {
      return '-';
    };
    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let second = date.getSeconds();
    let result;
    switch (type) {
      case 0: // 01-05
        result = `${format(month)}-${format(day)}`;
        break;
      case 1: // 11:12
        result = `${format(hours)}-${format(minutes)}`;
        break;
      case 2: // 2015-01-05
        result = `${year}-${format(month)}-${format(day)}`;
        break;
      case 3: // 2015-01-05 11:12
        result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`;
        break;
      case 4: // 2015-01-05 11:12:06
        result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`;
        break;
      case 5: // h小时m分钟
        result = `${format(hours)}小时${format(minutes)}分钟`;
        break;
      case 6: // 2017年08月29日
        result = `${year}年${format(month)}月${format(day)}日`;
        break;
      default:
        result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`;
        break;
    };
    return result;
  }
};

export default {
  install (Vue) {
    for (let [prop, fn] of Object.entries(filters)) {
      Vue.filter(prop, fn);
    }
  }
};
